<template>
	<KkTeleport
		:to="appendTo"
		:disabled="!appendTo"
	>
		<transition
			name="dialog-fade"
			@after-enter="afterEnter"
			@after-leave="afterLeave"
			@before-leave="beforeLeave"
		>
			<div
				v-show="visible"
				class="kk-overlay"
				:style="{ zIndex: zIndex }"
			>
				<div
					role="dialog"
					aria-modal="true"
					class="kk-overlay-dialog"
					@click="overlayEvent.onClick"
					@mousedown="overlayEvent.onMousedown"
					@mouseup="overlayEvent.onMouseup"
				>
					<KkDialogContent
						v-if="rendered"
						ref="dialogRef"
						v-bind="$attrs"
						:size="size"
						:title-font="titleFont"
						:title="title"
						:is-show-back="isShowBack"
						:header-transparent="headerTransparent"
						:title-line-clamp="titleLineClamp"
						:extra-icon="extraIcon"
						:is-show-close="isShowClose"
						:is-show-header="isShowHeader"
						:scroll-target="scrollTarget"
						:max-height="maxHeight"
						:is-show-box-shadow="isShowBoxShadow"
						:body-class="bodyClass"
						:is-show-footer="isShowFooter"
						:footer-direction="footerDirection"
						:footer-align="footerAlign"
						:footer-options="footerOptions"
						@close="handleClose"
						@back="$emit('back')"
						@extra-icon="$emit('extra-icon')"
					>
						<template #header>
							<slot
								v-if="!$slots.title"
								name="header"
							/>
						</template>
						<slot />
						<template
							v-if="$slots.footer"
							#footer
						>
							<slot name="footer" />
						</template>
					</KkDialogContent>
				</div>
			</div>
		</transition>
	</KkTeleport>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useWindowSize } from '@vueuse/core'
import KkTeleport  from '../../KkTeleport'
import useDialog from './useDialog'
import { useSameTarget } from '../../hooks/useSameTarget'
import KkDialogContent from './KkDialogContent.vue'
import { dialogProps, dialogEmits } from './dialog'

const props = defineProps(dialogProps)
const emits = defineEmits(dialogEmits)

const dialogRef = ref(null)

const { height } = useWindowSize()
const maxHeight = computed(() => {
	return props.maxHeight > (height.value - 80) ? (height.value - 80) : props.maxHeight;
})

const {
	zIndex,
	visible,
	rendered,
	doClose: handleClose,
	beforeLeave,
	afterLeave,
	afterEnter,
	onModalClick
} = useDialog(
	props,
	emits,
	dialogRef,
);

const overlayEvent = useSameTarget(onModalClick)
</script>
